/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 */

// TODO: https://framagit.org/flopedt/FlOpEDT/-/issues/99
export const DOCUMENTATION_WEBSITE = 'https://cdn.cynthia.dev/documentation-18062024.png'
